import { action, makeObservable, observable, reaction } from 'mobx';
import { FREE_BET_STATUS } from '../core/constants/freeBet';
import { userInfoStore } from './userInfoStore';
import { parseNumberByPrecision } from '../core/helpers/parseNumberByPrecision';
import { autoBetStore } from './autoBetStore';
import { AllGamesConfigurations } from '../core/constants/gameIds';
import { DefaultQueryParams } from '../core/constants/defaultQueryParams';
import { parseQuery } from '../core/helpers/parseQuery';

class FreeBetStore {
  freeBetList = [];

  currentFreeBet = null;

  isShowFreeBetPopup = false;

  constructor() {
    makeObservable(this, {
      freeBetList: observable,
      currentFreeBet: observable,
      isShowFreeBetPopup: observable,
      setFreeBetList: action.bound,
      showFreeBetInfo: action.bound,
      setCurrentFreeBet: action.bound,
      setIsShowFreeBetPopup: action.bound,
      updateCurrentFreeBetInList: action.bound,
    });

    reaction(
      () => this.isShowFreeBetPopup,
      (value) => {
        const { resetAutoBetState } = autoBetStore;
        if (value) {
          resetAutoBetState();
        }
      }
    );
  }

  showFreeBetInfo(userFreeBets) {
    const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
    const gameInfo = AllGamesConfigurations[gameId];
    this.setFreeBetList(userFreeBets);
    const currentFreeBet = userFreeBets.find(
      (freeBet) =>
        FREE_BET_STATUS.accepted === freeBet.status || FREE_BET_STATUS.pending === freeBet.status
    );
    this.setCurrentFreeBet(currentFreeBet);
    if (currentFreeBet) {
      if (currentFreeBet.status === FREE_BET_STATUS.pending) {
        this.setIsShowFreeBetPopup(true);
      }
      if (gameInfo.isGameInChips) {
        const selectedQuickBet = userInfoStore.quickBets.find(
          (item) => item.value === currentFreeBet.amount
        );
        userInfoStore.setSelectedChip(selectedQuickBet?.chip);
      }
      userInfoStore.setBetAmount(
        parseNumberByPrecision(currentFreeBet.amount, 1, userInfoStore.precision)
      );
    }
  }

  setIsShowFreeBetPopup(bool) {
    this.isShowFreeBetPopup = bool;
  }

  setFreeBetList(list) {
    this.freeBetList = list;
  }

  setCurrentFreeBet(currentFreeBet) {
    this.currentFreeBet = currentFreeBet;
  }

  updateCurrentFreeBetInList() {
    const freeBetIndex = this.freeBetList.findIndex((item) => item.id === this.currentFreeBet.id);
    this.freeBetList.splice(freeBetIndex, 1, this.currentFreeBet);
  }

  updateCurrentFreeBet(updatedFreeBet) {
    this.currentFreeBet = {
      ...this.currentFreeBet,
      ...updatedFreeBet,
    };
    this.updateCurrentFreeBetInList();
  }
}

export const freeBetStore = new FreeBetStore();
